function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M155.25 132H121.5V87H155.25V132ZM155.25 64.5H114V79.5H155.25V64.5ZM162.75 132H196.5V87H162.75V132ZM162.75 64.5V79.5H204V64.5H162.75ZM179.134 42C168.082 42 161.618 55.0387 159 60.75H179.044C192.142 60.75 192.281 42 179.134 42ZM176.149 55.5788H168.487C171.259 51.375 173.884 48.2062 177.27 48.2062C181.665 48.2062 181.875 55.5788 176.149 55.5788ZM138.956 60.75H159C156.382 55.0387 149.917 42 138.866 42C125.719 42 125.858 60.75 138.956 60.75ZM140.73 48.2062C144.116 48.2062 146.741 51.375 149.513 55.5788H141.851C136.125 55.5788 136.335 48.2062 140.73 48.2062Z",
  fill: "url(#paint0_radial_20022703_73976)"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M120 111.984C111.369 112.768 106.411 113.49 103.367 115.873C99.7889 118.664 98.9415 123.776 98 134C97.0271 123.4 96.1484 118.319 92.2254 115.591C89.1812 113.458 84.2539 112.768 76 112.016C84.5991 111.232 89.5892 110.51 92.602 108.158C96.2111 105.336 97.0585 100.255 98 90C98.8787 99.4398 99.6633 104.489 102.582 107.406C105.501 110.322 110.585 111.138 120 111.984Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M229 47.489C222.919 48.0413 219.426 48.5495 217.281 50.2288C214.76 52.1953 214.163 55.7969 213.5 63C212.815 55.5317 212.195 51.9522 209.432 50.0299C207.287 48.5274 203.815 48.0413 198 47.511C204.058 46.9587 207.574 46.4505 209.697 44.7933C212.24 42.8047 212.837 39.2252 213.5 32C214.119 38.6507 214.672 42.2081 216.728 44.263C218.785 46.3179 222.367 46.8924 229 47.489Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M238 127.489C231.919 128.041 228.426 128.55 226.281 130.229C223.76 132.195 223.163 135.797 222.5 143C221.815 135.532 221.195 131.952 218.432 130.03C216.287 128.527 212.815 128.041 207 127.511C213.058 126.959 216.574 126.45 218.697 124.793C221.24 122.805 221.837 119.225 222.5 112C223.119 118.651 223.672 122.208 225.728 124.263C227.785 126.318 231.367 126.892 238 127.489Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_20022703_73976",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(159 87) rotate(118.848) scale(40.4155)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#88F59C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFF3A2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_20022703_73976",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(167.7 62.7) rotate(129.629) scale(49.8578)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 180,
    viewBox: "0 0 318 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M155.25 132H121.5V87H155.25V132ZM155.25 64.5H114V79.5H155.25V64.5ZM162.75 132H196.5V87H162.75V132ZM162.75 64.5V79.5H204V64.5H162.75ZM179.134 42C168.082 42 161.618 55.0387 159 60.75H179.044C192.142 60.75 192.281 42 179.134 42ZM176.149 55.5788H168.487C171.259 51.375 173.884 48.2062 177.27 48.2062C181.665 48.2062 181.875 55.5788 176.149 55.5788ZM138.956 60.75H159C156.382 55.0387 149.917 42 138.866 42C125.719 42 125.858 60.75 138.956 60.75ZM140.73 48.2062C144.116 48.2062 146.741 51.375 149.513 55.5788H141.851C136.125 55.5788 136.335 48.2062 140.73 48.2062Z",
    fill: "url(#paint1_radial_20022703_73976)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.8595b30c05413a6b1c64efab56ce36f4.svg";
export { ForwardRef as ReactComponent };